<template>
  <LineChart :chart-data="chartData" :chart-options="chartOptions" :styles="styles"/>
</template>

<script>
import { Line as LineChart } from 'vue-chartjs'

export default {
      components: {
            LineChart
      },
      props: {
            chartdata: {
                  type: Object,
                  default: null
            },
            options: {
                  type: Object,
                  default: null
            },
            styles: {
                  type: Object,
                  default: () => {}
            }
      },
      data() {
        let extendedChartData = this.chartdata;
        let chartOptions = structuredClone(this.options)
        chartOptions.elements = {
          line:
              {
                borderColor: 'rgba(241, 242, 242, 1)',
                tension: 0.4
              }
        }
        return {
              chartData: extendedChartData,
              chartOptions: chartOptions
        }
      }
}
</script>